import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';
import { PiGraduationCap } from 'react-icons/pi';
import { FormattedMessage } from 'react-intl';
import { CategoryIcon } from '@_/components';
import { Link, Skeleton, SkeletonText } from '@_/ui';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { navI18n } from '#src/i18nMessages/index.ts';
import { CategoryNavPopover } from './CategoryNavPopover.tsx';
import { DesktopNavItem } from './DesktopNavItem.tsx';

export function DesktopMainNav() {
  const categoryNavQuery = useQuery({
    ...getReactQueryOptions(publicApiQueryClient.metadata.getCategoryNav),
    staleTime: Duration.fromObject({ minutes: 5 }).toMillis()
  });

  if (categoryNavQuery.isPending) {
    return (
      <div className="flex h-9 items-center gap-x-2">
        <Skeleton className="grid w-80 grid-cols-3 gap-x-6">
          <SkeletonText />
          <SkeletonText />
          <SkeletonText />
        </Skeleton>
      </div>
    );
  }

  const navItems = categoryNavQuery.data?.data;

  return (
    <div className="flex h-9 items-center gap-x-2">
      {navItems?.map(item => (
        <DesktopNavItem
          key={item.categoryId}
          icon={<CategoryIcon categorySlug={item.slug} />}
          renderLink={props => (
            <Link
              {...props}
              from="/{-$locale}"
              to="/{-$locale}/courses/$categorySlug"
              params={{ categorySlug: item.slug }}
            />
          )}
          renderPopover={
            item.contents && Object.keys(item.contents).length
              ? ({ onClose }) => (
                  <CategoryNavPopover
                    categorySlug={item.slug}
                    contents={item.contents}
                    onClose={onClose}
                  />
                )
              : undefined
          }
          label={item.label}
        />
      ))}
      <DesktopNavItem
        icon={<PiGraduationCap />}
        label={<FormattedMessage {...navI18n.browseSchools} />}
        renderLink={props => <Link {...props} from="/{-$locale}" to="/{-$locale}/schools" />}
      />
    </div>
  );
}
